import { cloudApiClient } from '@/services/clientSideCloudApiService';

interface TrackSearchEventArgs {
  keyword: string;
  resultCount: number;
}

interface TrackSearchEventResponse {
  message: string;
}

export const trackSearchEvent = async function (args: TrackSearchEventArgs) {
  return await cloudApiClient.post<TrackSearchEventResponse>('preset/track-search-event', args);
};
